module.exports = __webpack_public_path__ + "media/11.923758f3.mp3";